import React from 'react';
import css from './SectionOfferingsForm.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import { FieldArray } from 'react-final-form-arrays';
import { Field, useFormState } from 'react-final-form';
import { FieldCheckbox } from '../../../components';
import { isArrayLength } from '../../../util/genericHelpers';
const InstructionsFormField = () => {
  const intl = useIntl();
  const { values } = useFormState();
  const { deliverViaDM } = values || {};
  return (
    <div className={css.deliveryInstructionsSection}>
      <label htmlFor="deliverViaDM">
        <FormattedMessage id="InstructionsFormField.title" />
      </label>
      {/* Deliver via DM Checkbox */}
      <FieldCheckbox
        id="deliverViaDM"
        name="deliverViaDM"
        label={intl.formatMessage({
          id: 'InstructionsFormField.deliverViaDM',
          defaultMessage: 'Deliver via DM',
        })}
        value="true"
      />
      {isArrayLength(deliverViaDM) && (
        <FieldArray name="instructions">
          {({ fields }) => (
            <>
              {fields.map((name, index) => (
                <div key={name} className={css.instructionRow}>
                  <Field name={name}>
                    {({ input }) => (
                      <input
                        {...input}
                        type="text"
                        placeholder={intl.formatMessage(
                          { id: 'InstructionsFormField.instructionPlaceholder' },
                          { index: index + 1 }
                        )}
                        className={css.input}
                      />
                    )}
                  </Field>

                  <button
                    type="button"
                    onClick={() => fields.remove(index)}
                    disabled={fields.length === 1}
                    className={`${css.removeBtn} ${fields.length === 1 ? css.disabled : ''}`}
                  >
                    <FormattedMessage id="InstructionsFormField.removeButton" />
                  </button>
                </div>
              ))}

              <button type="button" onClick={() => fields.push('')} className={css.addBtn}>
                <FormattedMessage id="InstructionsFormField.addButton" />
              </button>
            </>
          )}
        </FieldArray>
      )}
    </div>
  );
};

export default InstructionsFormField;
